<template>
  <div>
    <div
      id="edit_abilities_root"
      class="w-full h-full"
    ></div>
  </div>
</template>

<script setup>
import { nextTick, onBeforeUnmount, onMounted } from 'vue';
import Tools from '~/Tools';
import CanvasTools from '~/view/CanvasTools';
import EditAbilities_canvas from '../canvas/edit_abilities/EditAbilities';

let _canvas_root;

onMounted(() => {
  nextTick(renderCanvas);
  window.addEventListener('resize', handleResize);
  window.addEventListener('orientationchange', handleResize);
});

onBeforeUnmount(() => {
  _canvas_root?.dispose();
  _canvas_root = null;
  window.removeEventListener('resize', handleResize);
  window.removeEventListener('orientationchange', handleResize);
});

function renderCanvas() {
  _canvas_root?.dispose();
  _canvas_root = new EditAbilities_canvas();
  const { x, y, height } = CanvasTools.getDomAnchor('edit_abilities_root');
  _canvas_root.x = x;
  _canvas_root.y = y - height * 0.2;
  DT_CANVAS_GLOBALS.stage.addChildAt(_canvas_root, 1);
}

const handleResize = Tools.debounce(renderCanvas, 300);
</script>
